/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProblemDetails } from '../model/problemDetails';
import { RouteImplementationDto } from '../model/routeImplementationDto';
import { RouteImplementationModel } from '../model/routeImplementationModel';
import { RouteImplementationModelSingleResponseDto } from '../model/routeImplementationModelSingleResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AggregatorRouteImplementationService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param systemName 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAggregatorRouteImplementationDetailGet(systemName?: string, id?: string, observe?: 'body', reportProgress?: boolean): Observable<RouteImplementationModel>;
    public apiAggregatorRouteImplementationDetailGet(systemName?: string, id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RouteImplementationModel>>;
    public apiAggregatorRouteImplementationDetailGet(systemName?: string, id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RouteImplementationModel>>;
    public apiAggregatorRouteImplementationDetailGet(systemName?: string, id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (systemName !== undefined && systemName !== null) {
            queryParameters = queryParameters.set('systemName', <any>systemName);
        }
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RouteImplementationModel>('get',`${this.basePath}/api/AggregatorRouteImplementation/detail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAggregatorRouteImplementationDetailsGet(observe?: 'body', reportProgress?: boolean): Observable<Array<RouteImplementationModel>>;
    public apiAggregatorRouteImplementationDetailsGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RouteImplementationModel>>>;
    public apiAggregatorRouteImplementationDetailsGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RouteImplementationModel>>>;
    public apiAggregatorRouteImplementationDetailsGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<RouteImplementationModel>>('get',`${this.basePath}/api/AggregatorRouteImplementation/details`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAggregatorRouteImplementationGetIdIdGet(id: string, observe?: 'body', reportProgress?: boolean): Observable<RouteImplementationModel>;
    public apiAggregatorRouteImplementationGetIdIdGet(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RouteImplementationModel>>;
    public apiAggregatorRouteImplementationGetIdIdGet(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RouteImplementationModel>>;
    public apiAggregatorRouteImplementationGetIdIdGet(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiAggregatorRouteImplementationGetIdIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RouteImplementationModel>('get',`${this.basePath}/api/AggregatorRouteImplementation/GetId/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAggregatorRouteImplementationPost(body?: RouteImplementationDto, observe?: 'body', reportProgress?: boolean): Observable<RouteImplementationModelSingleResponseDto>;
    public apiAggregatorRouteImplementationPost(body?: RouteImplementationDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RouteImplementationModelSingleResponseDto>>;
    public apiAggregatorRouteImplementationPost(body?: RouteImplementationDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RouteImplementationModelSingleResponseDto>>;
    public apiAggregatorRouteImplementationPost(body?: RouteImplementationDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<RouteImplementationModelSingleResponseDto>('post',`${this.basePath}/api/AggregatorRouteImplementation`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
